import { Reveal, Overline } from "@/components/Reveal";

const ROWS = [
  { label: "Traject", now: "±7 km", proposal: "±7 km" },
  { label: "Theoretische rijtijd", now: "±4 min 12 sec", proposal: "±5 min 15 sec" },
  { label: "Verschil", now: "—", proposal: "±1 minuut", highlight: true },
  { label: "Verkeersgeluid", now: "hoger", proposal: "lager" },
  { label: "Uitstoot conventionele auto's", now: "hoger bij hoge kruissnelheid", proposal: "potentieel lager" },
  { label: "Leefkwaliteit omgeving", now: "huidige situatie", proposal: "verbetering beoogd" },
];

export const Comparison = () => (
  <section id="vergelijking" data-testid="comparison-section" className="scroll-mt-24 bg-gooi-sand py-24 md:py-32">
    <div className="mx-auto max-w-[90rem] px-5 md:px-12">
      <Reveal>
        <Overline>De vergelijking</Overline>
        <h2 className="mt-4 max-w-3xl font-display text-3xl font-medium leading-tight tracking-tight text-gooi-green md:text-5xl lg:text-6xl">
          Vandaag versus ons voorstel
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-2">
        <Reveal>
          <div
            data-testid="comparison-card-100"
            className="rounded-2xl border border-gooi-green/15 bg-gooi-offwhite p-8 md:p-12"
          >
            <p className="text-xs uppercase tracking-[0.25em] text-gooi-green/50">Vandaag</p>
            <p className="mt-4 font-display text-6xl font-semibold tracking-tighter text-gooi-green/85 md:text-8xl">
              100
              <span className="ml-2 text-2xl font-medium tracking-tight text-gooi-green/50 md:text-3xl">km/u</span>
            </p>
            <p className="mt-4 text-sm leading-relaxed text-gooi-green/65">
              De huidige maximumsnelheid op dit deel van de A1.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <div
            data-testid="comparison-card-80"
            className="rounded-2xl bg-gooi-green p-8 text-gooi-offwhite md:p-12"
          >
            <p className="text-xs uppercase tracking-[0.25em] text-gooi-offwhite/60">Ons voorstel</p>
            <p className="mt-4 font-display text-6xl font-semibold tracking-tighter md:text-8xl">
              80
              <span className="ml-2 text-2xl font-medium tracking-tight text-gooi-offwhite/60 md:text-3xl">km/u</span>
            </p>
            <p className="mt-4 text-sm leading-relaxed text-gooi-offwhite/70">
              Structureel 80 km/u tussen Naarden/Bussum en Eemnes, in beide rijrichtingen.
            </p>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.15}>
        <div className="mt-12 overflow-x-auto rounded-2xl border border-gooi-green/15 bg-gooi-offwhite">
          <table data-testid="comparison-table" className="w-full min-w-[560px] text-left text-sm md:text-base">
            <thead>
              <tr className="border-b border-gooi-green/15">
                <th scope="col" className="px-6 py-5 font-display text-xs font-semibold uppercase tracking-[0.2em] text-gooi-green/50 md:px-8">
                  &nbsp;
                </th>
                <th scope="col" className="px-6 py-5 text-right font-display text-sm font-semibold uppercase tracking-[0.15em] text-gooi-green/70 md:px-8">
                  100 km/u
                </th>
                <th scope="col" className="px-6 py-5 text-right font-display text-sm font-semibold uppercase tracking-[0.15em] text-gooi-forest md:px-8">
                  80 km/u
                </th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row) => (
                <tr key={row.label} className="border-b border-gooi-green/10 last:border-0">
                  <th scope="row" className="px-6 py-5 font-semibold text-gooi-green md:px-8">
                    {row.label}
                  </th>
                  <td className="px-6 py-5 text-right text-gooi-green/65 md:px-8">{row.now}</td>
                  <td
                    className={`px-6 py-5 text-right md:px-8 ${
                      row.highlight ? "font-display text-lg font-semibold text-gooi-red" : "text-gooi-green"
                    }`}
                  >
                    {row.proposal}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-4 max-w-2xl text-xs leading-relaxed text-gooi-green/55">
          Rijtijden zijn theoretische waarden bij constante snelheid over circa 7 kilometer en geen voorspelling
          van werkelijke reistijden. Werkelijke reistijd hangt af van verkeer en doorstroming.
        </p>
      </Reveal>
    </div>
  </section>
);
